import React, { Component } from 'react';
import './static/style/App.css';
import IphonePage from './components/iPhonePage';
import AndroidPage from './components/androidPage';
import { isAndroid, isIOS } from "./static/js/util/env";
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式
import './static/style/process.less';
import './static/style/mixin.less';

class App extends Component{
  render() {
    return (
      <div className="main-wrapper">
        {isIOS ? (<IphonePage></IphonePage>) : null}
        {isAndroid ? (<AndroidPage></AndroidPage>) : null}
      </div>
    );
  }
  componentWillMount() {
    NProgress.start();
    this.setRem(document.documentElement.clientWidth * 100 / 750);
  }
  componentDidMount() {
    NProgress.done()
  }
  setRem(rem) { // 设置rem
    // document.documentElement.style = 'font-size: ' + rem + 'px';
    document.documentElement.setAttribute('style', 'font-size: ' + rem + 'px');
  }
}

export default App;
